import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { filesize } from 'filesize';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { mimeTypeToIconMapping } from '../../helpers/mime-type_to_icon';

import {
	getFiles as onGetFiles,
	updateFile as onupdateFile,
	downloadFile as onDownloadFile,
	updateFileFavourites as onUpdateFileFavourites,
} from '../../slices/thunks';
import { UploadFileModal } from './UploadFileModal';
import { ODataGrid } from '../../Components/OElements/ODataGrid';
import { Alert, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';

export const Files = props => {
	const {
		current_folder,
		has_folders,
		handleFile,
		handleCreateFolder,
		query
	} = props;

	const dispatch = useDispatch();

	const [fileDownloadLoading, setFileDownloadLoading] = useState(null);

	// Files
	const [file, setFile] = useState(null);
	const [selectionList, setSelectionList] = useState([]);
	const [modalCreateFile, setModalCreateFile] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [refetchData, setRefetchData] = useState();
	const [sidebarData, setSidebarData] = useState("");


	const selectorFiles = createSelector(
		state => state.FileManager,
		result => ({
			files: result.files,
			isLoadingFiles: result.isLoadingFiles,
		})
	);

	const { files, isLoadingFiles } = useSelector(selectorFiles);

	const fileToggle = useCallback(() => {
		if (modalCreateFile) {
			setModalCreateFile(false);
			setFile(null);
		} else {
			setModalCreateFile(true);
		}
	}, [modalCreateFile]);

	// Update File
	const handleFileClick = useCallback(
		arg => {
			const file = arg;

			setFile({
				id: file.id,
				fileName: file.fileName,
				fileItem: file.fileItem,
				size: file.size,
			});

			setIsEdit(true);
			fileToggle();
		},
		[fileToggle]
	);

	// Add File
	const handleFileClicks = () => {
		setFile('');
		setModalCreateFile(!modalCreateFile);
		setIsEdit(false);
		fileToggle();
	};

	// Delete File
	const onClickFileDelete = file => {
		setFile(file);
		setDeleteModal(true);
	};

	const dateFormat = () => {
		let d = new Date(),
			months = [
				'Jan',
				'Feb',
				'Mar',
				'Apr',
				'May',
				'Jun',
				'Jul',
				'Aug',
				'Sep',
				'Oct',
				'Nov',
				'Dec',
			];
		return (
			d.getDate() +
			' ' +
			months[d.getMonth()] +
			', ' +
			d.getFullYear()
		).toString();
	};

	const favouriteBtn = (ele, file_id) => {
		if (ele.closest('button').classList.contains('active')) {
			dispatch(
				onUpdateFileFavourites({
					file_id,
					action: 'remove',
				})
			).then(data => {
				if (!data.payload.isFavourite)
					ele.closest('button').classList.remove('active');
			});
		} else {
			dispatch(
				onUpdateFileFavourites({
					file_id,
					action: 'add',
				})
			).then(data => {
				if (data.payload.isFavourite)
					ele.closest('button').classList.add('active');
			});
		}
	};

	const fileSidebar = () => {
		document.getElementById("folder-overview").style.display = "none";
		document.getElementById("file-overview").style.display = "block";
	};

	// File validation
	// const fileValidation = useFormik({
	// 	// enableReinitialize : use this flag when initial values needs to be changed
	// 	enableReinitialize: true,

	// 	initialValues: {
	// 		folder_id: current_folder?._id || '/',
	// 	},
	// 	validationSchema: Yup.object({
	// 		fileName: Yup.string().required('Please Enter File Name'),
	// 	}),
	// 	onSubmit: values => {
	// 		if (isEdit) {
	// 			const updateFile = {
	// 				folder_id: current_folder?._id || '/',
	// 			};
	// 			// save edit File
	// 			dispatch(onupdateFile(updateFile));
	// 			fileValidation.resetForm();
	// 		} else {
	// 			const newFile = {
	// 				id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(),
	// 				fileName: values.fileName + '.txt',
	// 				fileItem: '0',
	// 				icon: 'ri-file-text-fill',
	// 				iconClass: 'secondary',
	// 				fileType: 'Documents',
	// 				size: '0 KB',
	// 				createDate: dateFormat(),
	// 			};
	// 			// save new File

	// 			console.log(newFile);
	// 			//dispatch(onAddNewFile(newFile));
	// 			fileValidation.resetForm();
	// 		}
	// 		fileToggle();
	// 	},
	// });

	const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
	const togglePreviewModal = () => setIsPreviewModalOpen(!isPreviewModalOpen);
	const [previewFile, setPreviewFile] = useState(null);

	const handlePreviewClick = async (file) => {
		try {
			const data = await dispatch(onDownloadFile({ file_id: file._id, disable_msg: true }));
			const fileURL = window.URL.createObjectURL(data.payload);
			setPreviewFile({ ...file, url: fileURL });
			togglePreviewModal();
		} catch (error) {
			console.error('Error al obtener el archivo:', error);
		}
	};


	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'guide', // Ajusta el accessorKey según sea necesario
				columnDefType: 'display',

				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={e => {
													e.preventDefault();
													setFileDownloadLoading(
														cellProps.row.original._id
													);
													dispatch(
														onDownloadFile({
															file_id:
																cellProps.row.original._id,
														})
													)
														.then(data => {
															const payload = data.payload;
															const url =
																window.URL.createObjectURL(
																	payload
																);
															const link =
																document.createElement('a');
															link.href = url;
															link.setAttribute(
																'download',
																`${cellProps.row.original.filename}${cellProps.row.original.extension}`
															);
															document.body.appendChild(link);
															link.click();
														})
														.finally(() =>
															setFileDownloadLoading(null)
														);
												}}
											>
												{fileDownloadLoading ===
													cellProps.row.original._id ? (
													<div
														className='spinner-border spinner-border-xs'
														role='status'
													>
														<span className='visually-hidden'>
															Loading...
														</span>
													</div>
												) : (
													<i className='icon-download align-bottom me-2 text-muted' />
												)}
											</Link>
										</li>

										<li className='list-inline-item'>
											<Link to='#' onClick={(e) => { e.preventDefault(); handlePreviewClick(cellProps.row.original); }}>
												<i className='ri-eye-line align-bottom me-2 text-muted' />
											</Link>
										</li>

										{/* <li className='list-inline-item'>
											<Link
												to='#'
												onClick={e => {
													e.preventDefault();
													handleFileClick(cellProps.row.original);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted' />
											</Link>
										</li> */}
										{/* <li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={e => {
													e.preventDefault();
													onClickFileDelete(
														cellProps.row.original
													);
												}}
											>
												<i className='ri-delete-bin-6-fill align-bottom me-2 text-muted' />
											</Link>
										</li> */}
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'filename',
				filterVariant: 'autocomplete',
				Cell: cellProps => {
					return (
						<div className='d-flex align-items-center'>
							<div className='flex-shrink-0 fs-13 me-2 filelist-icon'>
								<i
									className={
										mimeTypeToIconMapping[
											cellProps.row.original.mime_type
										].icon +
										'-fill' +
										' align-bottom'
									}
									style={{
										color: mimeTypeToIconMapping[
											cellProps.row.original.mime_type
										].color,
									}}
								/>
							</div>
							<div className='flex-grow-1 filelist-name'>
								{cellProps.row.original.filename}
								{cellProps.row.original.extension}
							</div>
						</div>
					);
				},
			},
			{
				header: 'Tipo',
				accessorKey: 'file_type',

				size: 'auto',
				Cell: ({ row }) => {
					return row.original.file_type
						? row.original.file_type.name
						: '-';
				},
			},
			{
				header: 'Importante',
				accessorKey: 'isFavourite',
				Cell: cellProps => {
					return (
						<div className='d-flex justify-content-center'>
							<button
								type='button'
								className={`btn btn-ghost-primary btn-icon btn-sm favourite-btn ${cellProps.row.original.isFavourite ? 'active' : ''
									}`}
								onClick={e =>
									favouriteBtn(e.target, cellProps.row.original._id)
								}
							>
								<i className='ri-star-fill align-bottom me-2 text-muted' />
							</button>
						</div>
					);
				},
			},
			{
				header: 'Establecimiento',
				accessorKey: 'establishment',
				Cell: ({ row }) => {
					let establishment = row.original.establishment
					if (establishment) {
						return establishment.name
					}
					return '-'
				},
			},
			{
				header: 'Tamaño',
				accessorKey: 'size',
				Cell: cellProps => {
					return (
						<div className='filelist-size'>
							{filesize(cellProps.row.original.size || 0)}
						</div>
					);
				},
			},
		],
		[]
	);



	return (
		<div>
			<Row className='justify-content-beetwen g-2 mb-3'>
				<Col>
					<h5 className='flex-grow-1 fs-13 mb-0' id='filetype-title'>
						Archivos
					</h5>
				</Col>
				<Col className='col-auto'>
					<div className='d-flex gap-2 align-items-start'>
						<button
							type='button'
							className='btn btn-label btn-success createFile-modal'
							onClick={() => (handleFile ? handleFile() : handleFileClicks())}
						>
							<i className='ri-file-upload-line label-icon'></i> Subir Archivo
						</button>

						{!has_folders && (
							<button
								type='button'
								className='btn btn-label btn-primary'
								onClick={() => handleCreateFolder()}
							>
								<i className='ri-folder-add-line label-icon'></i>
								Crear Carpeta
							</button>
						)}
					</div>
				</Col>
			</Row>
			<Row>
				<Col>
					<ODataGrid
						key={'files_' + current_folder?._id || ''}
						getDataFunc={onGetFiles}
						columns={columns}
						// selection={{
						// 	rowSelection: selectionList,
						// 	setRowSelection: setSelectionList,
						// }}
						remoteOperations={{
							pagination: true,
							sorting: true,
							filtering: true,
						}}
						baseFilters={
							query
								? query
								: {
									folder_id: {
										...(current_folder?._id !== '/'
											? {
												$eq: current_folder?._id,
											}
											: {
												$null: true,
											}),
									},
									disable: {
										$eq: false,
									},
								}
						}
						refetchRemoteData={refetchData}
					/>
				</Col>

			</Row>

			{/* Modal de Previsualización */}
			<Modal isOpen={isPreviewModalOpen} toggle={togglePreviewModal} size='lg'>
				<ModalHeader toggle={togglePreviewModal}>Previsualización</ModalHeader>
				<ModalBody>
					{previewFile && previewFile.url ? (
						previewFile.mime_type.includes('image') ? (
							<img src={previewFile.url} alt={previewFile.filename} className='img-fluid' />
						) : previewFile.mime_type.includes('pdf') ? (
							<iframe src={previewFile.url} width='100%' height='500px' />
						) : previewFile.mime_type.includes('text') ? (
							<pre>{previewFile.content || 'No se pudo cargar el contenido'}</pre>
						) : (
							<p>Formato no compatible para previsualización.</p>
						)
					) : (
						<p>Cargando...</p>
					)}
				</ModalBody>
			</Modal>

			<UploadFileModal
				folder_id={current_folder?._id || '/'}
				isOpen={modalCreateFile}
				setIsOpen={setModalCreateFile}
				isEdit={isEdit}
				setRefetchData={setRefetchData}
			// form={fileValidation}
			/>
		</div>
	);
};
